import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Skeleton, Box } from '@mui/material';
import { Column } from 'react-table';

interface TableSkeletonProps {
  columns: Column<any>[];
  rowCount?: number;
}

const columnWidths = [
  '5%', // S.NO
  '10%', // ROLE
  '25%', // FUNCTION NAME
  '10%', // MODIFIED BY
  '10%', // MODIFIED DATE
  '15%' // ACTION
];

const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rowCount = 10 }) => (
  <Table>
    <TableHead>
      <TableRow>
        {columns.map((column, index) => (
          <TableCell key={index} sx={{ width: columnWidths[index] }}>
            <Skeleton variant="text" width="80%" />
          </TableCell>
        ))}
        <TableCell sx={{ width: columnWidths[columnWidths.length - 1] }}>
          <Skeleton variant="text" width="40%" />
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {columns.map((_, colIndex) => (
            <TableCell key={colIndex} sx={{ width: columnWidths[colIndex] }}>
              <Skeleton variant="rectangular" width="100%" height={10} sx={{ borderRadius: 1, marginY: 0.5 }} />
            </TableCell>
          ))}
          <TableCell sx={{ width: columnWidths[columnWidths.length] }}>
            <Box display="flex" justifyContent="center" gap={1}>
              <Skeleton variant="circular" width={20} height={20} />
              <Skeleton variant="circular" width={20} height={20} />
              <Skeleton variant="circular" width={20} height={20} />
              <Skeleton variant="circular" width={20} height={20} />
            </Box>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default TableSkeleton;
